
import { defuFn } from '/usr/src/nuxt-app/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
